export default __webpack_public_path__ + "static/media/837.a56d0510.gif";